import {get, post} from './api';

// 提交分享
const shareSave = post('project/update')


// 分享列表
const shareList = get('project/my-shared')


// 评论列表
const commentList = get('comment/list')

// 评论
const commentSave = post('comment/save');

// 获取微信授权
const getWXSignature = get('weixin/get-signature')



export {
    commentSave,
    shareSave,
    commentList,
    shareList,
    getWXSignature
}